import { appGo } from "@/app/navigate";
import { useProjectStore } from "@/store/project-store";

/** Jump to the schedule tab with a WBS/Activity focused in the grid, Gantt and inspector. */
export function openScopeInSchedule(projectId: string, scheduleTaskId: string) {
  appGo(`/projects/${projectId}/schedule`);
  // let the route mount before touching selection / scroll requests
  requestAnimationFrame(() => {
    const s = useProjectStore.getState();
    if (s.activeId !== projectId) return;
    s.select([scheduleTaskId], scheduleTaskId);
    s.setUI({ sidePanel: "inspector" });
    const st = s.derived.schedule.tasks.get(scheduleTaskId);
    if (st) s.scrollToDate(st.start, "third");
  });
}

/** Open the tasks tab filtered to items linked to a schedule node (and its descendants). */
export function openLinkedTasks(projectId: string, scheduleTaskId: string) {
  appGo(`/projects/${projectId}/tasks?linked=${encodeURIComponent(scheduleTaskId)}`);
}

/**
 * Open an execution task's detail drawer in place.
 * Loads the project into the editor when needed so the drawer can edit it
 * without leaving the current page (e.g. 내 작업).
 */
export function openExecutionTask(projectId: string, executionTaskId: string, tab: "tasks" | "calendar" = "tasks") {
  const s = useProjectStore.getState();
  if (s.activeId !== projectId) {
    if (!s.openProject(projectId)) {
      appGo(`/projects/${projectId}/${tab}?open=${encodeURIComponent(executionTaskId)}`);
      return;
    }
  }
  s.setExecutionFocus(executionTaskId);
}
